import React, { useState } from "react";
import {
  Chip,
  Menu,
  MenuItem,
  Stack,
  FormHelperText,
  Tooltip,
  Checkbox,
  ListItemText,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function ServiceNeeded({
  value,
  activeProduct,
  formData,
  onChange = () => {},
  error,
  operation = "edit",
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [subMenuAnchor, setSubMenuAnchor] = useState(null);

  const servicesNeeded = value?.servicesNeeded || [];
  const serviceOrder = [
    "Recce",
    "Fabrication",
    "Printing",
    "Painting",
    "Installation",
  ];

  const sortedServices = [...servicesNeeded].sort((a, b) => {
    const indexA = serviceOrder.indexOf(a);
    const indexB = serviceOrder.indexOf(b);

    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  });

  const handleChipClick = (event, chipName) => {
    if (operation === "view") return;

    if (chipName === "Supply") {
      setAnchorEl(event.currentTarget);
    } else {
      let updated = [...servicesNeeded];
      if (updated.includes(chipName)) {
        updated = updated.filter((s) => s !== chipName);
      } else {
        updated.push(chipName);
      }
      onChange({ ...value, servicesNeeded: updated });
    }
  };

  const toggleService = (option) => {
    let updated = [...servicesNeeded];
    if (updated.includes(option)) {
      updated = updated.filter((s) => s !== option);
    } else {
      updated.push(option);
    }
    onChange({ ...value, servicesNeeded: updated });
  };

  // Tooltip text for Supply chip
  const supplySelected = servicesNeeded.filter((s) =>
    ["Fabrication", "Printing", "Painting"].includes(s),
  );
  const supplyTooltip =
    supplySelected.length > 0
      ? supplySelected.join(", ")
      : "No option selected";

  const activeProductData = formData.products.find(
    (ele) => ele.productType === activeProduct,
  );

  return (
    <div className="mb-2">
      <label
        className={`text-[12px] font-[500] mb-1 mt-4 ${
          error && "text-[var(--error-color)]"
        }`}
      >
        Service Needed *
      </label>

      {operation != "view" ? (
        <Stack direction="row" className="flex-wrap gap-2 mt-2">
          {["Recce", "Supply", "Installation"].map((service, index) => {
            const isSupply = service === "Supply";
            const isActive = isSupply
              ? servicesNeeded.some((s) =>
                  ["Fabrication", "Printing", "Painting"].includes(s),
                )
              : servicesNeeded.includes(service);

            const chip = (
              <Chip
                key={index}
                label={
                  isSupply ? (
                    <span className="flex items-center gap-1">
                      Supply <ArrowDropDownIcon fontSize="small" />
                    </span>
                  ) : (
                    service
                  )
                }
                variant="outlined"
                disabled={operation == "view"}
                onClick={(e) => handleChipClick(e, service)}
                sx={{
                  cursor: operation === "view" ? "default" : "pointer",
                  borderColor: isActive ? "#418cff" : "gray",
                  color: isActive ? "#418cff" : "gray",
                }}
              />
            );

            return isSupply ? (
              <Tooltip key={index} title={supplyTooltip} arrow>
                {chip}
              </Tooltip>
            ) : (
              chip
            );
          })}
        </Stack>
      ) : (
        <>
          <Stack direction="row" className="flex-wrap gap-2 mt-2">
            {sortedServices.map((service, index) => (
              <Chip
                key={index}
                label={service}
                variant="outlined"
                // disabled={operation == "view"}
                sx={{
                  cursor: operation === "view" ? "default" : "pointer",
                  borderColor: "#418cff",
                  color: "#418cff",
                }}
              />
            ))}
          </Stack>
        </>
      )}

      {/* Main Supply Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={() => toggleService("Printing")}>
          <Checkbox checked={servicesNeeded.includes("Printing")} />
          <ListItemText primary="Printing" />
        </MenuItem>

        <MenuItem onClick={() => toggleService("Fabrication")}>
          <Checkbox checked={servicesNeeded.includes("Fabrication")} />
          <ListItemText primary="Fabrication" />
        </MenuItem>

        {/* Other → Nested submenu */}
        <MenuItem
          disabled={activeProductData?.servicesNeeded?.some((service) =>
            ["Printing", "Fabrication"].includes(service),
          )}
          onClick={(e) => setSubMenuAnchor(e.currentTarget)}
        >
          <ListItemText primary="Other ➝" />
        </MenuItem>
      </Menu>

      {/* Submenu for Other */}
      <Menu
        anchorEl={subMenuAnchor}
        open={Boolean(subMenuAnchor)}
        onClose={() => setSubMenuAnchor(null)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem onClick={() => toggleService("Painting")}>
          <Checkbox checked={servicesNeeded.includes("Painting")} />
          <ListItemText primary="Painting" />
        </MenuItem>
      </Menu>

      {error && (
        <FormHelperText
          className="text-[var(--error-color)] text-[12px] -mt-3 ml-3"
          sx={{
            color: "var(--error-color)",
            marginTop: 1,
            marginLeft: 1.5,
          }}
        >
          {error}
        </FormHelperText>
      )}
    </div>
  );
}
